import { useEffect, useState } from 'react';

import { useDeviceInfo } from '@/utils/use-device-info';

// Public Chrome Web Store ID for the Loom extension. Not a secret and not
// environment-scoped — the `chrome-extension://` probe URL below is
// Chrome-specific and this ID is a stable public identifier.
const LOOM_CHROME_EXTENSION_ID = 'liecbddmkiiihnedobmlmillhodjkdmb';

// A web-accessible resource the extension ships. If Loom ever renames this
// file the probe silently returns `false`, so keep it aligned with the
// extension's stable public surface.
const PROBE_IMAGE_PATH = 'img/installed.jpg';

/**
 * Detects whether the Loom Chrome extension is installed by trying to load a
 * web-accessible image the extension ships. Returns `false` outside Chrome
 * desktop and until the probe settles.
 */
export const useIsLoomExtensionInstalled = (): boolean => {
	const { isChrome, isMobile } = useDeviceInfo();
	const [installed, setInstalled] = useState(false);

	useEffect(() => {
		if (!isChrome || isMobile) return;

		let cancelled = false;
		const img = new Image();
		img.onload = () => !cancelled && setInstalled(true);
		img.onerror = () => !cancelled && setInstalled(false);
		img.src = `chrome-extension://${LOOM_CHROME_EXTENSION_ID}/${PROBE_IMAGE_PATH}`;

		return () => {
			cancelled = true;
		};
	}, [isChrome, isMobile]);

	return installed;
};
